<script lang="ts">
  import Authorization from "@shared/svelte/Components/Authorization.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import UIRouterLink from "@shared/svelte/Components/UIRouterLink.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import PageWrapper from "@retailer/svelte/Shared/PageWrapper.svelte";
  import Popover from "@shared/svelte/Components/Popover/Popover.svelte";

  import UserContext from "@modern/services/user_context";
  import CurrentUserStore from "@shared/svelte/Stores/CurrentUserStore";

  export let distributorContext;
  export let user;
  export let trueUserDisplayName;

  let salesRepPreviewLoading = false;
  const logout = function () {
    window.location.href = "/users/fully_log_out";
  };

  let activeDistributors = distributorContext.getAllDistributors();
  let currentDistributor = distributorContext.getCurrentDistributor();

  function distributorPaymentsEnabled(activeDistributors) {
    return activeDistributors.some(distributor => distributor.uses_term_payments);
  }

  $: accountDisplayName = UserContext.userNameString($CurrentUserStore);

  let selfManagedInventory = (activeDistributors[0] || {}).self_managed_inventory;

  let onboardRetailers =
    currentDistributor?.uses_referrals == "onboard_retailers" && currentDistributor.integrated;

  let acceptedRoles = ["distributor_admin", "payments_admin"];
  let usesSellSheets = currentDistributor?.uses_sell_sheets;
  let usesStorefronts = currentDistributor?.uses_storefronts;
  let paymentsPagePermitted =
    distributorPaymentsEnabled(activeDistributors) &&
    acceptedRoles.includes(currentDistributor.role);

  const clickHome = function () {
    if (!user) {
      return;
    }
    window.location.href = "/distributor";
  };

  const newSalesRepRetailerPreview = function () {
    salesRepPreviewLoading = true;
    HttpPromise({
      url: "/api/distributor/sales_reps/preview",
      method: "POST",
    }).then(function (res) {
      window.location.href = "/";
    });
  };

  let logoImageUrl = window["$rootScope"].C.IMAGE_PATHS["logo_white.svg"];
</script>

<PageWrapper let:mobileMode>
  <header class="rep-confirm__header position-fixed full-width color-white background-brandPrimary">
    <div class="grid-container padding-top--smaller padding-bottom--smaller">
      <div class="grid-row">
        <div class="grid-col c12-12 vertical-align-middle">
          <div class="media">
            <div
              on:click={clickHome}
              on:keydown={clickHome}
              class="media-fixed rep-confirm__logo cursor-pointer"
              style="background-image: url('{logoImageUrl}')"
            ></div>
            <div class="media-fluid align-right align-self-center vertical-align-middle">
              <ul
                class="list list--horizontal list--align-middle align-right light-subheader--regular"
              >
                {#if !mobileMode}
                  <Authorization authName="orders.index">
                    <li class="list-item cursor-pointer">
                      <UIRouterLink stateName={"layout.orders"} classes="fizz-text-inverse">
                        Orders
                      </UIRouterLink>
                    </li>
                  </Authorization>
                  <Authorization authName="retailers.index">
                    <li class="list-item cursor-pointer">
                      <UIRouterLink stateName={"layout.retailers"} classes="fizz-text-inverse">
                        Retailers
                      </UIRouterLink>
                    </li>
                  </Authorization>
                  <Authorization authName="sales_reps.show">
                    <li class="list-item cursor-pointer">
                      <UIRouterLink stateName={"layout.sales_reps"} classes="fizz-text-inverse">
                        Employees
                      </UIRouterLink>
                    </li>
                  </Authorization>
                  {#if usesSellSheets}
                    <Authorization authName="sell_sheets.index">
                      <li class="list-item cursor-pointer">
                        <UIRouterLink
                          stateName={"layout.product_sheets"}
                          classes="fizz-text-inverse"
                        >
                          Product Sheets
                        </UIRouterLink>
                      </li>
                    </Authorization>
                  {/if}
                  {#if onboardRetailers}
                    <li class="list-item cursor-pointer">
                      <UIRouterLink
                        stateName={"layout.retailer_onboarding"}
                        classes="fizz-text-inverse"
                      >
                        Onboard Retailers
                      </UIRouterLink>
                    </li>
                  {/if}
                  <li class="list-item cursor-pointer">
                    <div>
                      {#if salesRepPreviewLoading}
                        <div class="fizz-styles">
                          <div class="fizz-icon-spinner-small vertical-align-middle"></div>
                        </div>
                      {/if}
                      {#if !salesRepPreviewLoading}
                        <Authorization authName="sales_reps.preview">
                          <a
                            on:click={newSalesRepRetailerPreview}
                            on:keydown={newSalesRepRetailerPreview}
                            class="fizz-text-inverse">Retailer Preview</a
                          >
                        </Authorization>
                      {/if}
                    </div>
                  </li>
                {/if}
                <li class="list-item cursor-pointer position-relative settings-popover-link">
                  <Popover arrow={false} placement="bottom-end" let:setOpen>
                    <div
                      slot="target"
                      class="cursor-pointer fizz-flex-row-4"
                      data-testid="usernavbaropen"
                    >
                      {#if trueUserDisplayName}
                        <Icon
                          type="Warning"
                          height="16"
                          width="16"
                          color="#ECC032"
                          extraClassNames="fizz-icon"
                        />
                      {/if}
                      <span class="fizz-text-regular">
                        {accountDisplayName}
                      </span>
                      <Icon
                        type="ChevronDown"
                        height="12"
                        width="12"
                        extraClassNames="fizz-icon cursor-pointer"
                      />
                    </div>
                    <div
                      slot="content"
                      class="retailer-header__account-popover__contents fizz-popover color-brandPrimary"
                    >
                      <ul class="fizz-text-large fizz-color-black">
                        {#if trueUserDisplayName}
                          <li class="color-black fizz-inset-square-16">
                            <div class="default-small--bold">
                              {trueUserDisplayName} logged in as {accountDisplayName}
                            </div>
                          </li>
                        {/if}
                        <li class="list-item hr" />
                        <li
                          class="underline-hover fizz-border-none"
                          on:click={setOpen}
                          on:keydown={setOpen}
                        >
                          <UIRouterLink stateName={"layout.profile"}>
                            <div class="fizz-flex-row fizz-inset-square-8">
                              <Icon
                                extraClassNames="fizz-icon cursor-pointer"
                                type="User"
                                height="20"
                                width="20"
                              />
                              <div class="settings-link">Profile</div>
                            </div>
                          </UIRouterLink>
                        </li>
                        <li
                          class="underline-hover fizz-border-none"
                          on:click={setOpen}
                          on:keydown={setOpen}
                        >
                          <UIRouterLink stateName={"layout.home"}>
                            <div class="fizz-flex-row fizz-inset-square-8">
                              <Icon
                                extraClassNames="fizz-icon cursor-pointer"
                                type="History"
                                height="20"
                                width="20"
                              />
                              <div>Orders</div>
                            </div>
                          </UIRouterLink>
                        </li>
                        <li
                          class="underline-hover fizz-border-none"
                          on:click={setOpen}
                          on:keydown={setOpen}
                        >
                          <UIRouterLink stateName={"layout.retailers"}>
                            <div class="fizz-flex-row fizz-inset-square-8">
                              <Icon
                                extraClassNames="fizz-icon cursor-pointer"
                                type="Cart"
                                height="20"
                                width="20"
                              />
                              <div>Retailers</div>
                            </div>
                          </UIRouterLink>
                        </li>
                        {#if activeDistributors[0].role != "product_manager"}
                          <li
                            class="underline-hover fizz-border-none"
                            on:click={setOpen}
                            on:keydown={setOpen}
                          >
                            <UIRouterLink stateName={"layout.notifications"}>
                              <div class="fizz-flex-row fizz-inset-square-8">
                                <Icon
                                  extraClassNames="fizz-icon cursor-pointer"
                                  type="Bell"
                                  height="20"
                                  width="20"
                                />
                                <div>Notifications</div>
                              </div>
                            </UIRouterLink>
                          </li>
                        {/if}
                        <li
                          class="underline-hover fizz-border-none"
                          on:click={setOpen}
                          on:keydown={setOpen}
                        >
                          <UIRouterLink stateName={"layout.vacations"}>
                            <div class="fizz-flex-row fizz-inset-square-8">
                              <Icon
                                extraClassNames="fizz-icon cursor-pointer"
                                type="Calendar"
                                height="20"
                                width="20"
                              />
                              <div>Vacations</div>
                            </div>
                          </UIRouterLink>
                        </li>
                        {#if usesSellSheets}
                          <li
                            class="underline-hover fizz-border-none"
                            on:click={setOpen}
                            on:keydown={setOpen}
                          >
                            <UIRouterLink stateName={"layout.product_sheets"}>
                              <div class="fizz-flex-row fizz-inset-square-8">
                                <Icon
                                  extraClassNames="fizz-icon cursor-pointer"
                                  type="Pencil"
                                  height="20"
                                  width="20"
                                />
                                <div>Product Sheets</div>
                              </div>
                            </UIRouterLink>
                          </li>
                        {/if}
                        {#if usesStorefronts}
                          <li
                            class="underline-hover fizz-border-none"
                            on:click={setOpen}
                            on:keydown={setOpen}
                          >
                            <UIRouterLink stateName={"layout.storefronts"}>
                              <div class="fizz-flex-row fizz-inset-square-8">
                                <Icon
                                  extraClassNames="fizz-icon cursor-pointer"
                                  type="Storefront"
                                  height="20"
                                  width="20"
                                />
                                <div>Storefronts</div>
                              </div>
                            </UIRouterLink>
                          </li>
                        {/if}
                        <li
                          class="underline-hover fizz-border-none"
                          on:click={setOpen}
                          on:keydown={setOpen}
                        >
                          <UIRouterLink stateName={"layout.sales_reps"}>
                            <div class="fizz-flex-row fizz-inset-square-8">
                              <Icon
                                extraClassNames="fizz-icon cursor-pointer"
                                type="Clipboard"
                                height="20"
                                width="20"
                              />
                              <div>Employees</div>
                            </div>
                          </UIRouterLink>
                        </li>
                        <Authorization authName="sales_reps.preview">
                          <li
                            class="underline-hover fizz-border-none"
                            on:click={setOpen}
                            on:keydown={setOpen}
                          >
                            {#if !salesRepPreviewLoading}
                              <a
                                on:click={newSalesRepRetailerPreview}
                                on:keydown={newSalesRepRetailerPreview}
                                >
                                <div class="fizz-flex-row fizz-inset-square-8">
                                  <Icon
                                    extraClassNames="fizz-icon cursor-pointer"
                                    type="MartiniGlass"
                                    height="20"
                                    width="20"
                                  />
                                  <div>Retailer Preview</div>
                                </div>
                              </a>
                            {/if}
                          </li>
                        </Authorization>
                        {#if selfManagedInventory}
                          <li
                            class="underline-hover fizz-border-none"
                            on:click={setOpen}
                            on:keydown={setOpen}
                          >
                            <UIRouterLink stateName={"layout.products"}>
                              <div class="fizz-flex-row fizz-inset-square-8">
                                <Icon
                                  extraClassNames="fizz-icon cursor-pointer"
                                  type="Keg"
                                  height="20"
                                  width="20"
                                />
                                <div>Products</div>
                              </div>
                            </UIRouterLink>
                          </li>
                        {/if}
                        {#if onboardRetailers}
                          <li
                            class="underline-hover fizz-border-none"
                            on:click={setOpen}
                            on:keydown={setOpen}
                          >
                            <UIRouterLink stateName={"layout.retailer_onboarding"}>
                              <div class="fizz-flex-row fizz-inset-square-8">
                                <Icon
                                  extraClassNames="fizz-icon cursor-pointer"
                                  type="Onboard"
                                  height="20"
                                  width="20"
                                />
                                <div>Onboard Retailers</div>
                              </div>
                            </UIRouterLink>
                          </li>
                        {/if}
                        {#if paymentsPagePermitted}
                          <li
                            class="underline-hover fizz-border-none"
                            on:click={setOpen}
                            on:keydown={setOpen}
                          >
                            <UIRouterLink stateName={"layout.payments"}>
                              <div class="fizz-flex-row fizz-inset-square-8">
                                <Icon
                                  extraClassNames="fizz-icon cursor-pointer"
                                  type="ProviPay"
                                  height="20"
                                  width="20"
                                />
                                <div>Payments</div>
                              </div>
                            </UIRouterLink>
                          </li>
                        {/if}
                        <li class="list-item hr"></li>
                        <li
                          class="fizz-border-none underline-hover"
                          on:click={setOpen}
                          on:keydown={setOpen}
                        >
                          <div class="fizz-flex-row fizz-inset-square-8">
                            <a
                              on:click={logout}
                              on:keydown={logout}
                              class="cursor-pointer underline-hover display-block"
                            >
                              Logout
                            </a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </Popover>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</PageWrapper>
